"use client";

import { useMemo } from "react";

import IconImageSparkle from "@ui/central-icons/icons/IconImageSparkle";
import IconImages1 from "@ui/central-icons/icons/IconImages1";
import IconSparkle from "@ui/central-icons/icons/IconSparkle";
import { iconStrokeFix } from "@ui/central-icons/iconUtils";
import type { FeatureItem } from "@ui/components/core/SignUpPopover";
import clsx from "clsx";
import { useTranslations } from "next-intl";

/**
 * The "sign up to keep creating" value-prop bullets shown after a flow-template
 * run. Shared by the standalone `BlockFlowTemplate`, the creative hero, and the
 * gallery modal so the icon + copy set stays in sync across all three (it had
 * already started to drift when inlined per call site).
 */
export function useSignUpFeatureItems() {
  const t = useTranslations("ClientKeys.creative_templates");
  return useMemo<[FeatureItem, ...FeatureItem[]]>(
    () => [
      {
        icon: <IconImageSparkle className={clsx(iconStrokeFix, "tw-size-[18px]")} />,
        text: t("signup_popover_feature_1"),
      },
      { icon: <IconSparkle className={clsx(iconStrokeFix, "tw-size-[18px]")} />, text: t("signup_popover_feature_2") },
      { icon: <IconImages1 className={clsx(iconStrokeFix, "tw-size-[18px]")} />, text: t("signup_popover_feature_3") },
    ],
    [t],
  );
}
